package org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.price_level

data class PriceLevelItem(
    val value: String?,
    val index: Int
)